import axiosPost from "../axiosPost";

export const hotelIns = async (
    params = {},
    credentials
) => {
    const body = {
        service: "SFHotelIns",
        params: {
            SFHotelNombre: params?.SFHotelNombre,
            SFHotelDomicilioCalle: params?.SFHotelDomicilioCalle,
            SFHotelDomicilioCasa: params?.SFHotelDomicilioCasa,
            SFHotelDomicilioCPA: params?.SFHotelDomicilioCPA,
            localidadId: params?.localidadId,
            SFHotelLatitud: params?.SFHotelLatitud,
            SFHotelLongitud: params?.SFHotelLongitud,
            SFHotelCUIT: params?.SFHotelCUIT,
            SFHotelCheckin: params?.SFHotelCheckin,
            SFHotelCheckout: params?.SFHotelCheckout,
        },
    };

    const result = await axiosPost(body, credentials);
    return result;
};
